// https://leafletjs.com/reference-1.7.1.html#geojson-option
export const stateMapStyles = {
    fillColor: '#aaa',
    fillOpacity: '0.4',
    color: '#fff',
};

export const miniMapStyles = {
    fillColor: '#aaa',
    fillOpacity: '0.4',
    color: '#444',
    weight: 0.3,
};

export const schoolIcon = {
    className: 'lmz-icon lmz-school-icon',
    iconSize: [18, 18],
};

/**
 * Get options for a support icon depending on a given id
 *
 * @param {Number} id currently 1-5
 * @returns Object
 */
export function getSupportIcon(id) {
    return {
        className: `lmz-icon lmz-support-icon lmz-support-icon-${id}`,
        iconSize: [14, 14],
    };
}
